import styled from "styled-components";

import { Text } from "@ui/Atoms";

export const HeaderText = styled(Text).attrs({
  as: "h2",
  $style: {
    default: "bold_40",
    smallTablet: "bold_56",
    smallDesktop: "bold_72",
  },
  $color: "white",
  $breakWord: true,
})``;
